import { createFileRoute } from "@tanstack/react-router";
import { DefiPortfolioPositionsPage } from "../../features/defi/pages/defi-portfolio-positions-page";

export const Route = createFileRoute("/_layout/defi/portfolio/positions")({
  component: DefiPortfolioPositionsPage,
});
